module.exports = __webpack_public_path__ + "static/d22013-3582a4c7d1faf6da92845b9d4a1c22cc.jpg";